<template>
  <div>
    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <h4>Órdenes de compra de clientes</h4>
        <div>
          <button class="btn btn-sm btn-outline-info mr-2" @click="modal.uploadXML = true">Subir XML</button>
          <button class="btn btn-sm btn-success">Nueva</button>
        </div>
      </div>
      <div class="card-body">
        <h5>Filtros</h5>

        <div class="d-flex flex-wrap mt-3">
          <div class="form-group col-3">
            <label for="">Monto min.</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">Monto max.</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">Folio</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">Fecha desde</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">Fecha hasta</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">RFC receptor</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">RFC emisor</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">Estado</label>
            <input type="text" class="form-control" />
          </div>
          <div class="col-12 d-flex justify-content-end mt-3">
            <button class="btn btn-primary">Buscar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col">Folio</th>
                <th scope="col">RFC Emisor</th>
                <th scope="col">RFC Receptor</th>
                <th scope="col">Monto</th>
                <th scope="col">Fecha de emisión</th>
                <th scope="col">Comprobante</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1</th>
                <td>Mark</td>
                <td>Otto</td>
                <td>@mdo</td>
                <td>@mdo</td>
                <td>
                  <a href="" class="btn btn-success btn-sm">Descargar</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <CModal title="Subir XML" :show.sync="modal.uploadXML" class="modalNoFooter">
      <div class="modal-body">
        <Filepond @uploaded="handleUploadXml" @onCancel="handleCancelUploadXml" />
      </div>

      <template #footer>
        <CButton @click="modal.uploadXML = false" color="outline-secondary">Cancelar</CButton>
        <CButton color="primary" :disabled="button.uploadXML">Subir</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Filepond from "../../componentes/tools/Docs.vue";

export default {
  components: {
    Filepond,
  },
  data() {
    return {
        modal: {
            uploadXML: false
        },
        button: {
            uploadXML: true
        }
    };
  },

  methods: {
      handleUploadXml(base64) {
          this.button.uploadXML = false
      },
      handleCancelUploadXml() {
          this.button.uploadXML = true;
      }
  }
};
</script>